import { render } from "./legendCard.vue?vue&type=template&id=2d8ebd28&scoped=true"
import script from "./legendCard.vue?vue&type=script&lang=js"
export * from "./legendCard.vue?vue&type=script&lang=js"

import "./legendCard.vue?vue&type=style&index=0&id=2d8ebd28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ebd28"]])

export default __exports__